import type { RootState } from '../../reducers';
import { aiAgentsSlice } from './agentsReducer';

export const selectAgents = (crmOrgId?: string) => (state: RootState) => {
  if (!crmOrgId) {
    return undefined;
  }
  return state[aiAgentsSlice.name].environments[crmOrgId]?.agents;
};

export const selectAgentsIsLoading = (crmOrgId?: string) => (state: RootState) => {
  if (!crmOrgId) {
    return undefined;
  }
  return state[aiAgentsSlice.name].environments[crmOrgId]?.isLoading;
};
